<div *ngIf="state$ | async as state" #shortlistContainer>
  <div *ngIf="state.showDetails" class="overlay" (click)="toggleDetails(false)"></div>
  <section>
    <button *ngIf="state.showDetails && state.isNarrowView" i18n="@@meal-plan-shortlist-hide-details" type="button" (click)="toggleDetails(false)" cdxButton [chip]="true" size="small" class="toggleDetails" [startSlotActive]="true" data-cy="hideDetailsButton">
      <cdx-svg-icon name="chevron-bottom" size="extra-small" fill="light" start></cdx-svg-icon>
      <span>Hide details</span>
    </button>
    <h3 i18n="@@meal-plan-shortlist-added-meals">You've added {{ mealList.length }} {{ mealList.length > 1 ? 'meals' : 'meal' }}</h3>
    <div class="list-gradient-overlay" [ngClass]="{ showOverlayLeft: state.showOverlayLeft, showOverlayRight: state.showOverlayRight }">
      <ul #shortlist>
        <li *ngFor="let meal of mealList">
          <recipe-meal-plan-shortlist-meal
            [meal]="meal" [imageUrl]="meal.recipe.imageUrl" [isNarrowView]="state.isNarrowView" [showDetails]="state.showDetails"
            (remove)="removeMeal($event)"
          ></recipe-meal-plan-shortlist-meal>
        </li>
      </ul>
    </div>
  </section>
  <div class="shortlist-summary">
    <button *ngIf="!state.showDetails && state.isNarrowView" i18n="@@meal-plan-shortlist-view-details" type="button" (click)="toggleDetails(true)" cdxButton [chip]="true" size="small" class="toggleDetails" [startSlotActive]="true" data-cy="showDetailsButton">
      <cdx-svg-icon name="chevron-top" size="extra-small" fill="light" start></cdx-svg-icon>
      <span>View details</span>
    </button>
    <p i18n="@@meal-plan-shortlist-total">Est. total <span>${{ totalPrice }}</span></p>
    <button *ngIf="state.showDetails || !state.isNarrowView" i18n="@@meal-plan-shortlist-review" cdxButton fillStyle="outline" size="small" [fullWidth]="true" type="button" (click)="reviewPlan()" data-cy="reviewPlanButton">Review your plan</button>
  </div>
</div>